export const AI_BUILDER_SETTING_NAME = 'ai_builder';

export const AI_BUILDER_SETTING_VALUES = Object.freeze({
    YES: 'YES',
    NOT_YET_PLANNING_TO: 'NOT_YET_PLANNING_TO',
    NO: 'NO',
});
